// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"04e2519f","703":"eb56f63e"}[chunkId] + ".chunk.js";
};